export default {
  hotSiteToken (state) {
    return state.hotSiteToken
  },
  avaliableSchedule (state) {
    return state.avaliableSchedule
  },
  client (state) {
    return state.client
  },
  item (state) {
    return state.item
  },
  itens (state) {
    return state.itens
  },
  loadingCheckout (state) {
    return state.loadingCheckout
  },
  paymentChoosen (state) {
    return state.paymentChoosen
  },
  priceVariation (state) {
    return state.item === null ? false : state.item.priceVariation
  },
  itemChoosen (state, getters) {
    if (state.item === null) return false
    if (state.itemChoosen === '') {
      return state.item.priceTable[0]
    } else {
      return state.item.priceTable.filter(elem => elem.provider === state.itemChoosen)[0]
    }
  },
  itensChoosen (state, getters) {
    return state.itensChoosen
  },
  itemChoosenDescription (state, getters) {
    return getters.itemChoosen !== false ? getters.itemChoosen.description : false
  },
  itemChoosenPrice (state, getters) {
    return getters.itemChoosen !== false ? getters.itemChoosen.price : false
  },
  itemChoosenPriceRef (state, getters) {
    return getters.itemChoosen !== false ? getters.itemChoosen.priceRef : false
  },
  dateChoosen (state) {
    return state.dateChoosen
  },
  timeChoosen (state) {
    return state.timeChoosen
  },
  unity (state) {
    if (state.client === null) return false
    return state.client.unity
  },
  unityChoosen (state) {
    return state.unityChoosen
  },
  acceptance (state) {
    return state.acceptance
  },
  requestSentModal (state) {
    return state.requestSentModal
  },
  loadingOrderRequest (state) {
    return state.loadingOrderRequest
  }
}



// WEBPACK FOOTER //
// ./src/store/Checkout/getters.js